import { render, staticRenderFns } from "./PImage.vue?vue&type=template&id=513fb69c"
import script from "./PImage.vue?vue&type=script&lang=js"
export * from "./PImage.vue?vue&type=script&lang=js"
import style0 from "./PImage.vue?vue&type=style&index=0&id=513fb69c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports